import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { ufService } from '../../services';
import { UF } from '../../types/pessoas';

const fields: ResourceField<UF>[] = [
  { name: 'sigla', label: 'Sigla', required: true },
  { name: 'nome', label: 'Nome', required: true },
  { name: 'codigo_ibge', label: 'Codigo IBGE', required: true },
];

export const UfsFormPage: React.FC = () => (
  <ResourceFormPage
    title="Nova UF"
    description="Cadastre unidades federativas para uso nos enderecos e cidades."
    fields={fields}
    service={ufService}
    redirectPath="/admin/pessoas/ufs"
    cancelPath="/admin/pessoas/ufs"
  />
);
